.container {
	position: relative;
	z-index: 3;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 20px;
	padding: 20px;
	align-self: stretch;
	border-radius: 10px 10px 0 0;
	border: 1px solid #d8e0e8;
	background: #f4f6f8;
	font-family: 'Ringside', sans-serif;
	.titol {
		font-size: 24px;
		line-height: 30px;
		font-weight: 700;
		color: #000;
		margin-bottom: 8px;
		&::after {
			content: '';
			display: block;
			width: 60px;
			height: 2px;
			background: #000;
			margin-top: 8px;
		}
	}
	.subtitol {
		font-size: 18px;
		line-height: 24px;
	}
	.container-input {
		width: 100%;
	}

	:global(.container-geocoder),
	:global(.mapboxgl-ctrl-geocoder) {
		width: 100%;
		max-width: none;
	}
}
